import Vue from "vue";

import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";

import router from "./router";
import store from "@/store";
import App from "./App";
import { axiosApi } from "@/common/js/api.js";
import NumberRange from '@/base/number-range'
import ActionLine from "@/base/action-line"
import Sticky from '@/base/Sticky'
import http from '@/utils/request'
import Sortable from 'sortablejs'

import './filters'
import "./assets/css/global.css";

// 全局注册 组件
Vue.component('number-range', NumberRange)
Vue.component('action-line', ActionLine)
Vue.component('sticky', Sticky)
console.log("ElementUI", ElementUI)
Vue.use(ElementUI, { size: 'small' });

Vue.prototype.$http = http;
Vue.prototype.axiosApi = axiosApi;
Vue.prototype.$Sortable = Sortable

Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  store,
  render: h => h(App)
}).$mount("#app");

// test: Blue Sky 井上大辅

// 



// WEBPACK FOOTER //
// ./src/main.js